const WORDS = [
  "Truck", "Mesa", "River", "Cedar", "Eagle", "Prairie", "Summit", "Harbor", "Canyon", "Maple",
  "Desert", "Falcon", "Granite", "Bison", "Pine", "Delta", "Ridge", "Valley", "Comet", "Thunder",
];

const pick = () => WORDS[crypto.getRandomValues(new Uint32Array(1))[0] % WORDS.length];

export function generatePassword() {
  const digits = String(1000 + (crypto.getRandomValues(new Uint32Array(1))[0] % 9000));
  return `${pick()}-${digits}-${pick()}`;
}

export function loginDetailsText(email, password) {
  const url = window.location.origin;
  return `Your Fleet Sheet login\nWebsite: ${url}\nEmail: ${email}\nPassword: ${password}`;
}

export function driverLoginText(username, password) {
  return `Your Fleet Sheet driver login\nSign in at: ${window.location.origin}/driver-login\nUsername: ${username}\nPassword: ${password}`;
}
